import { useState } from 'react';

import { DEFAULT_ROWS_PER_PAGE } from '../../../shared/constants/table.constants';
import { useAdminGetInvitations } from '../../../invitations/hooks/admin-get-invitations.hook';
import { InvitationsTable } from '../../../invitations/components/Tables/InvitationsTable.component';
import { SENDER_INVITATIONS_COLUMNS } from '../../../invitations/constants/invitations-table.constants';
import { InvitationSortColumn, InvitationSortDirection } from '../../../invitations/types/invitation.type';

type Props = {
  userId: string;
};

export function UserInvitationsTab({ userId }: Props) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_ROWS_PER_PAGE);
  const [sortBy, setSortBy] = useState<InvitationSortColumn>('deliveryDate');
  const [sortDirection, setSortDirection] = useState<InvitationSortDirection>('desc');

  const { isLoading, isRefetching, totalCount, invitations } = useAdminGetInvitations({
    page: page + 1,
    limit: rowsPerPage,
    sortBy,
    sortDirection,
    filters: { senderId: userId },
  });

  const handleSortChange = (column: InvitationSortColumn) => {
    setSortDirection(column === sortBy && sortDirection === 'desc' ? 'asc' : 'desc');
    setSortBy(column);
    setPage(0);
  };

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  return (
    <InvitationsTable
      invitations={invitations}
      totalCount={totalCount}
      page={page}
      rowsPerPage={rowsPerPage}
      isLoading={isLoading || isRefetching}
      sortBy={sortBy}
      sortDirection={sortDirection}
      columns={SENDER_INVITATIONS_COLUMNS}
      emptyLabel="Aucune invitation"
      maxHeight="70svh"
      onPageChange={setPage}
      onRowsPerPageChange={handleRowsPerPageChange}
      onSortChange={handleSortChange}
    />
  );
}
